import { Controller } from "@hotwired/stimulus"

// GeolocationPositionError.code の値（仕様で固定）
// Safari 15以前では GeolocationPositionError グローバルが未定義のため数値で参照
const PERMISSION_DENIED = 1
const POSITION_UNAVAILABLE = 2
const TIMEOUT = 3

export default class extends Controller {
  static targets = ["button", "status", "spinner"]
  static values = { url: String, autoFind: Boolean }

  connect() {
    this.disconnected = false
    if (document.documentElement.hasAttribute("data-turbo-preview")) return
    if (this.autoFindValue) this.find()
  }

  disconnect() {
    this.disconnected = true
  }

  find() {
    if (!window.isSecureContext) {
      this.#showError("位置情報を利用するにはHTTPS接続が必要です")
      return
    }

    if (!navigator.geolocation) {
      this.#showError("お使いのブラウザは位置情報に対応していません")
      return
    }

    this.#setLoading(true)

    navigator.geolocation.getCurrentPosition(
      (position) => this.#navigateToNearby(position),
      (error) => this.#showGeolocationError(error),
      { timeout: 10_000, maximumAge: 5 * 60_000 } // 10秒タイムアウト、5分キャッシュ
    )
  }

  #navigateToNearby(position) {
    if (this.disconnected) return
    const { latitude, longitude } = position.coords
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("lat", latitude.toFixed(3))
    url.searchParams.set("lng", longitude.toFixed(3))
    window.location.href = url.toString()
  }

  #showGeolocationError(error) {
    const messages = {
      [PERMISSION_DENIED]:
        "位置情報の使用が許可されていません。ブラウザの設定から位置情報の利用を許可してください。",
      [POSITION_UNAVAILABLE]:
        "現在地を取得できませんでした。電波状況の良い場所で再度お試しください。",
      [TIMEOUT]:
        "位置情報の取得がタイムアウトしました。再度お試しください。",
    }
    this.#showError(messages[error.code] || "位置情報の取得に失敗しました")
  }

  #showError(message) {
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.add("hidden")
    if (this.hasStatusTarget) this.statusTarget.textContent = message
    if (this.hasButtonTarget) {
      this.buttonTarget.classList.remove("hidden")
      this.buttonTarget.disabled = false
    }
  }

  #setLoading(loading) {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.toggle("hidden", !loading)
    }
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = loading ? "位置情報を取得中..." : ""
    }
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = loading
      if (loading) this.buttonTarget.classList.add("hidden")
    }
  }
}
